var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQuestTrackerMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 871",
  cx: 4,
  cy: 4,
  r: 4,
  transform: "translate(4 3.643)",
  fill: "#999"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 159743",
  fill: "none",
  d: "M0 0h16v16H0z"
})));
export default __webpack_public_path__ + "static/quest-tracker-marker.1ea289a6fce4b4f311a6073f95b027cf.svg";
export { SvgQuestTrackerMarker as ReactComponent };